const localeText = {
    // for filter panel
    page: 'Page',
    more: 'Plus',
    to: 'au',
    of: 'de',
    next: 'Suivant',
    last: 'Dérnier',
    first: 'Premier',
    previous: 'Précedent',
    loadingOoo: 'Chargement...',

    // for set filter
    selectAll: 'Sélectionner tous',
    searchOoo: 'Rechercher ...',
    blanks: 'Vide',

    // for number filter and text filter
    filterOoo: 'Filtrer...',
    applyFilter: 'Appliquer ...',
    equals: 'Egal à',
    notEqual: 'Pas égal à',

    // for number filter
    lessThan: 'moins que',
    greaterThan: 'Plus que',
    lessThanOrEqual: 'moins que ou égal',
    greaterThanOrEqual: 'Plus que ou égal',
    inRange: 'dans la gamme',

    // for text filter
    contains: 'Contient',
    notContains: 'Ne contient pas',
    startsWith: 'Commence par',
    endsWith: 'Termine par',

    // filter conditions
    andCondition: 'ET',
    orCondition: 'OU',

    // the header of the default group column
    group: 'Groupe',

    // tool panel
    columns: 'Colonnes',
    filters: 'Filtre',
    rowGroupColumns: 'le Pivot Cols',
    rowGroupColumnsEmptyMessage: 'la drag cols to group',
    valueColumns: 'Valeurs colones',
    pivotMode: 'Le Pivot-Mode',
    groups: 'Les groups',
    values: 'Les valeurs',
    pivots: 'Les pivots',
    valueColumnsEmptyMessage: 'la drag cols to aggregate',
    pivotColumnsEmptyMessage: 'la drag here to pivot',
    toolPanelButton: 'le tool panel',

    // other
    noRowsToShow: 'aucune ligne trouvée',

    // enterprise menu
    pinColumn: 'Epingler la colonne',
    valueAggregation: 'Agrégation de valeur',
    autosizeThiscolumn: 'Autoriser cette colonne',
    autosizeAllColumns: 'Autoriser tous',
    groupBy: 'Grouper par',
    ungroupBy: 'Dégrouper par',
    resetColumns: 'Réinitialiser',
    expandAll: 'Détacher tous',
    collapseAll: 'Attacher Tous',
    toolPanel: 'Boite utils',
    export: 'Exporter',
    csvExport: 'Sous forme (csv)',
    excelExport: 'Sous forme (.xlsx)',
    excelXmlExport: 'Sous forme (.xml)',

    // enterprise menu pinning
    pinLeft: '<< Épingle gauche',
    pinRight: 'Épingle droit >>',
    noPin: 'Sans épingle',

    // enterprise menu aggregation and status bar
    sum: 'Somme',
    min: 'Min',
    max: 'Max',
    none: 'Pas',
    count: 'compte',
    average: 'Moy',
    filteredRows: 'Filter les lignes',
    selectedRows: 'Selectionner les lignes',
    totalRows: 'Totals des lignes',
    totalAndFilteredRows: 'Total et filter les lignes',

    // standard menu
    copy: 'Copier',
    copyWithHeaders: 'Copier avec l\'êntete ',
    ctrlC: 'Ctr + C',
    paste: 'Coller',
    ctrlV: 'Ctr + V'
}

export default localeText